import { update_root_value } from "src/utils/domUtils";
import { tokens as defaultTokens, toCssVars } from "./tokens";

// Writes the design tokens to --gr-* CSS variables on <html>.
// Called once at start-up (src/config/config.js). A future theme switch calls it again
// with another token object of the same shape; every Gr element updates instantly.
export default function applyTokens(themeTokens = defaultTokens) {
  Object.entries(toCssVars(themeTokens)).forEach(([name, value]) =>
    update_root_value(name, value)
  );
}
